import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://faithfellowshipglobal.com';
const DEFAULT_IMAGE = `${BASE_URL}/assets/logos/logofull.webp`;

export const SEO_CONFIG = {
  '/': {
    title: 'Faith Fellowship Church – Ruwi, Oman | Born in Revival, Built on the Word',
    description: 'Welcome to Faith Fellowship Church in Ruwi, Muscat, Oman. Join us every Friday 8:15 PM – 10:15 PM at Old Main Hall, PCO Campus, Ruwi. Born in revival, built on the Word, carrying the fire to the nations.',
    keywords: 'Faith Fellowship Church, Faith Fellowship Church Ruwi, Church in Oman, Christian Church Ruwi, Pentecostal Church Oman, Pr Joby Titus, Pr Titus Chacko, Muscat Friday Worship, Church in Muscat',
    path: '/',
  },
  '/missionandvision': {
    title: 'Mission & Vision – Faith Fellowship Church | History & Global Mandate',
    description: 'Discover the story of Faith Fellowship Church, born in revival on 18 November 1998. Founded by Pr. Titus Chacko and led by Senior Pastor Pr. Joby Titus, raising a remnant for the nations.',
    keywords: 'Faith Fellowship Church History, Pr Titus Chacko, Pr Joby Titus, Church Mission Vision, Raising the Remnant, Christian Church Oman',
    path: '/missionandvision',
  },
  '/leadership': {
    title: 'Pastoral Team & Church Leadership – Faith Fellowship Church Ruwi',
    description: 'Meet the pastoral leadership of Faith Fellowship Church: Founder President Pr. Titus Chacko, Senior Pastor Pr. Joby Titus, Pastor Ciby Jacob, and branch pastors.',
    keywords: 'Pr Joby Titus, Pr Titus Chacko, Pr Ciby Jacob, Pr Jijimon Chacko, Pr P Satya Prasad, Pastors in Oman, Church Leadership Ruwi',
    path: '/leadership',
  },
  '/beliefs': {
    title: 'Statement of Faith & Core Biblical Beliefs – Faith Fellowship Church',
    description: 'Read our foundational Statement of Faith, core Christian doctrines, salvation through Jesus Christ, water baptism, and the empowering work of the Holy Spirit.',
    keywords: 'Statement of Faith, Church Beliefs, Christian Doctrine, Pentecostal Beliefs, Salvation in Jesus, Holy Spirit Baptism',
    path: '/beliefs',
  },
  '/bylaws': {
    title: 'Church Governance Bylaws (21 Articles) – Faith Fellowship Church',
    description: 'Read the official 21 Articles of Church Governance, leadership standards, spiritual integrity, financial accountability, and ministry gifts (Ephesians 4:11).',
    keywords: 'Church Bylaws, Church Constitution, Spiritual Governance, Five Fold Ministry Ephesians 4:11, Church Accountability',
    path: '/bylaws',
  },
  '/who-is-jesus': {
    title: 'Who Is Jesus? Gospel & Steps of Faith – Faith Fellowship Church',
    description: 'Discover the love, hope, and eternal life found in Jesus Christ. Learn the Gospel message, forgiveness of sins, and how to begin your personal walk with God.',
    keywords: 'Who is Jesus, Gospel Message, Salvation Prayer, Find Peace with God, Christian Faith, Jesus Christ',
    path: '/who-is-jesus',
  },
  '/branches': {
    title: 'Church Branches & Global Missions – Faith Fellowship Church',
    description: 'Explore Faith Fellowship Church branches in Ayoor (Kerala) and Velangi (Andhra Pradesh, South India), and our mission initiatives across India and Africa.',
    keywords: 'Faith Fellowship Church Branches, Ayoor Church Kerala, Velangi Church Andhra Pradesh, Global Missions India Africa',
    path: '/branches',
  },
  '/lambs': {
    title: "LAMBS Children's Ministry & Sunday School – Faith Fellowship Church",
    description: "LAMBS Children's Church at Faith Fellowship Church. Nurturing the next generation in the Word of God, prayer, and faith under Principal Pr. Ciby Jacob.",
    keywords: 'LAMBS Sunday School, Kids Ministry Oman, Christian Sunday School Ruwi, Pr Ciby Jacob, Children Church Muscat',
    path: '/lambs',
  },
  '/young-lion-cubs': {
    title: 'Young Lion Cubs Youth & Teens Ministry – Faith Fellowship Church',
    description: 'Young Lion Cubs Youth Ministry empowering teens and young adults to stand strong for Jesus, develop spiritual gifts, and lead revival in their generation.',
    keywords: 'Young Lion Cubs, Youth Ministry Ruwi, Christian Youth Fellowship Oman, Teen Church Muscat, Revival Generation',
    path: '/young-lion-cubs',
  },
  '/women': {
    title: "Women's Fellowship & Spiritual Mentorship – Faith Fellowship Church",
    description: "Women of Faith Fellowship at FFC Ruwi. Growing together in prayer, godly sisterhood, family encouragement, and spiritual mentorship.",
    keywords: "Women's Fellowship Oman, Christian Women Sisterhood, Prayer Warriors Ruwi, Mothers Ministry",
    path: '/women',
  },
  '/council': {
    title: 'Church Council & Advisory Board – Faith Fellowship Church',
    description: 'The advisory council and governing elder administration upholding biblical stewardship, prayer covering, and spiritual integrity at Faith Fellowship Church.',
    keywords: 'Church Council, Advisory Board, Church Elders Ruwi, Faith Fellowship Governance',
    path: '/council',
  },
  '/eventscalendar': {
    title: 'Service Timings & Events Calendar – Faith Fellowship Church Ruwi',
    description: 'Weekly worship schedules: Friday Main Service (8:15 PM – 10:15 PM at Old Main Hall, PCO Campus, Ruwi), Daily Dawn Prayer (4:00 AM), Night Vigils, and Fasting Prayers.',
    keywords: 'Church Timings Oman, Friday Worship Muscat, Ruwi Church Services, 4AM Dawn Prayer, Christian Calendar Oman',
    path: '/eventscalendar',
  },
  '/outreach': {
    title: 'Community Outreach & Compassion Ministry – Faith Fellowship Church',
    description: "Spreading Christ's compassion through local community outreach, hospital visits, charity support, and evangelism across Oman and beyond.",
    keywords: 'Church Outreach Oman, Charity Ministry Ruwi, Christian Care Muscat, Compassion in Action',
    path: '/outreach',
  },
  '/missiontrips': {
    title: 'Global Mission Trips & Evangelism – Faith Fellowship Church',
    description: 'Carrying the fire to the nations. Learn about Faith Fellowship Church cross-border missions, church planting, and evangelical conferences in India and Africa.',
    keywords: 'Christian Mission Trips, Africa Missions, Church Planting India, Global Evangelism',
    path: '/missiontrips',
  },
  '/prayer-request': {
    title: 'Submit a Prayer Request (24/7 Intercession) – Faith Fellowship Church',
    description: 'Need prayer? Submit your confidential prayer request to the pastoral intercession team at Faith Fellowship Church. We believe God answers prayer.',
    keywords: 'Prayer Request Oman, Christian Prayer Support, Healing Prayer, Intercessory Prayer Team Ruwi',
    path: '/prayer-request',
  },
  '/contact': {
    title: 'Contact Us & Driving Directions – Faith Fellowship Church Ruwi, Oman',
    description: 'Get in touch with Faith Fellowship Church. Location: Old Main Hall, PCO Campus, Ruwi, Muscat, Oman. Hotlines: +968 92537021 / +968 93970814. Email: faithfellowship.ora@gmail.com.',
    keywords: 'Contact Faith Fellowship Church, Church Location Ruwi, PCO Campus Driving Directions, Muscat Church Contact',
    path: '/contact',
  },
  '/new': {
    title: 'Plan Your Visit – Welcome to Faith Fellowship Church Ruwi',
    description: 'First time visiting? Everything you need to know about our Friday worship service in Ruwi, children church, location, and welcoming congregation.',
    keywords: 'Plan Your Visit Ruwi, Visitor Welcome Church Oman, New to Faith Fellowship, Muscat Worship Experience',
    path: '/new',
  },
  '/live-services': {
    title: 'Watch Live Services & Online Broadcasts – Faith Fellowship Church',
    description: 'Join our live worship service broadcasts online every Friday at 8:15 PM GST / Oman time. Stream uplifting praise, worship, and Spirit-led messages.',
    keywords: 'Watch Church Online Oman, Live Christian Broadcast, Friday Worship Stream, FFC Ruwi Live',
    path: '/live-services',
  },
  '/live': {
    title: 'Watch Live Services & Online Broadcasts – Faith Fellowship Church',
    description: 'Join our live worship service broadcasts online every Friday at 8:15 PM GST / Oman time. Stream uplifting praise, worship, and Spirit-led messages.',
    keywords: 'Watch Church Online Oman, Live Christian Broadcast, Friday Worship Stream, FFC Ruwi Live',
    path: '/live',
  },
  '/members-area': {
    title: 'Member Portal & Fellowship Gateway – Faith Fellowship Church',
    description: 'Online members portal for the Faith Fellowship Church congregation, ministry resources, and community updates.',
    keywords: 'Members Area FFC, Church Member Portal, Fellowship Resources',
    path: '/members-area',
  },
  '/blogs': {
    title: 'Pastoral Insights, Sermons & Articles – Faith Fellowship Church',
    description: 'Read uplifting spiritual articles, sermon transcripts, and biblical teachings from the pastoral team of Faith Fellowship Church.',
    keywords: 'Christian Blog Oman, Sermon Transcripts, Pastoral Devotionals, Biblical Teachings',
    path: '/blogs',
  },
};

function updateMetaTag(attrName, attrValue, content) {
  let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attrName, attrValue);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function updateLinkRel(rel, href) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
}

export function usePageSEO() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname.toLowerCase().replace(/\/$/, '') || '/';
    const config = SEO_CONFIG[pathname] || {
      title: 'Faith Fellowship Church – Ruwi, Oman | Born in Revival',
      description: 'Faith Fellowship Church in Ruwi, Oman. Raising the Remnant, carrying the fire of the Holy Spirit, and revealing Christ to the nations.',
      keywords: 'Faith Fellowship Church, Church in Oman, Christian Worship Ruwi',
      path: pathname,
    };

    const canonicalUrl = `${BASE_URL}${config.path === '/' ? '' : config.path}`;

    // 1. Update Document Title
    document.title = config.title;

    // 2. Update Standard Meta Tags
    updateMetaTag('name', 'description', config.description);
    updateMetaTag('name', 'keywords', config.keywords);

    // 3. Update Canonical Link
    updateLinkRel('canonical', canonicalUrl);

    // 4. Update OpenGraph Tags
    updateMetaTag('property', 'og:title', config.title);
    updateMetaTag('property', 'og:description', config.description);
    updateMetaTag('property', 'og:url', canonicalUrl);
    updateMetaTag('property', 'og:image', DEFAULT_IMAGE);

    // 5. Update Twitter Cards
    updateMetaTag('name', 'twitter:title', config.title);
    updateMetaTag('name', 'twitter:description', config.description);
    updateMetaTag('name', 'twitter:image', DEFAULT_IMAGE);

    // 6. Dynamic BreadcrumbList JSON-LD Schema
    const breadcrumbSchemaId = 'seo-breadcrumb-schema';
    let scriptTag = document.getElementById(breadcrumbSchemaId);
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = breadcrumbSchemaId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }

    const pathSegments = config.path.split('/').filter(Boolean);
    const itemList = [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `${BASE_URL}/`,
      },
    ];

    if (pathSegments.length > 0) {
      const pageName = config.title.split('–')[0].split('|')[0].trim();
      itemList.push({
        '@type': 'ListItem',
        position: 2,
        name: pageName,
        item: canonicalUrl,
      });
    }

    scriptTag.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: itemList,
    });
  }, [location.pathname]);
}
